<template lang="pug">
  main-layout#app.app-wrap
    template(v-slot:header)
      page-header
    template(v-slot:main)
      router-view
    template(v-slot:footer)
      polls-nav
      <v-dialog/>
</template>

<script>
  import { checkExistingSession } from '@/session';
  import { SESSION_COOKIE } from '@/constants';
  import * as utils from '@/utils';
  import MainLayout from '@/components/MainLayout.vue';
  import PageHeader from '@/components/PageHeader/PageHeader.vue';
  import PollsNav from '@/components/PollsNav/PollsNav.vue';

  export default {
    name: 'App',
    components: {
      'main-layout': MainLayout,
      'page-header': PageHeader,
      'polls-nav': PollsNav
    },
    computed: {
      hasAnswers () {
        return this.$store.state.answers.answers.length;
      }
    },
    mounted () {
      const needRemoveSession = checkExistingSession();
      if (needRemoveSession) {
        if (this.$router.history.current.name !== 'start') {
          this.$router.push('/');
        }
        this.$store.dispatch('session/removeSessionData');
        this.$store.dispatch('session/deleteUser');
        utils.setCookie(SESSION_COOKIE, null, { expires: -1 });
      }

      this.$once('setOnUnloadMessage', function () {
        window.onbeforeunload = function () {
          return 'При обновлении страницы данные не сохраняются. Продолжить?';
        }
      })
    },
    watch: {
      hasAnswers (val, prevVal) {
        if (val && val !== prevVal) {
          this.$emit('setOnUnloadMessage');
        }
      }
    }
  }
</script>

<style lang="scss" src="./assets/scss/main.scss"></style>
